import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isEqual } from 'lodash';

import * as dictionaryActions from '../../actions/dictionaryActions';

import clearIcon from '../../images/clear-field-icon.png';
import { ALL } from '../../constants';

const ANSWER = 1;
const QUESTION_ANSWER = 2;
const ALLRECORDS = 4;

class SearchComponentV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchBoxState: 'hide',
      searchText: '',
      treedata: this.props.dictionaryTree
        ? [...this.props.dictionaryTree.data]
        : [],
      clearBtnState: 'small button hide',
      searchBtnState: 'button search-button',
      searchTextBox: 'search-box',
      checkboxStatus: props.moduleStudy && props.moduleStudy.ss === 'MRI' ? 3 : 1,
      isDisabled: '',
      searchType: props.moduleStudy && props.moduleStudy.ss === 'MRI' ? 4 : 1,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      (this.props.activeAccountId !== nextProps.activeAccountId ||
      !isEqual(this.props.moduleStudy, nextProps.moduleStudy) ||
      (nextProps.refreshFlag !== this.props.refreshFlag)) &&
      this.props.loginResponse
    ) {
      if (nextProps.moduleStudy.ss === 'MRI') {
        this.handleSearchForAll()
      }
      this.handleClear(null, nextProps.moduleStudy.ss);
    }
  }

  toggleExpandedState = () => {
    if (this.state.searchBoxState === '') {
      this.setState({ searchBoxState: 'hide' });
    } else {
      this.setState({ searchBoxState: '' });
    }
  };

  handleSearch = () => {
    this.doSearch(this.state.searchType);
    this.setState({
      searchBoxState: 'hide',
      // searchTextBox: 'search-box is-disabled',
      searchBtnState: 'hide',
      clearBtnState: 'small button',
    });
  };

  handleSearchText = () => {
    if (this.clearBtn && this.searchBox.value === '') {
      this.clearBtn.click();
    } else {
      this.setState({ searchText: this.searchBox.value });
    }
  };

  handleKeyPress = e => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  };

  handleSearchRadio = type => {
    this.setState({ searchType: type });
    if (this.state.searchBtnState === 'hide') {
      this.doSearch(type);
      this.setState({
        searchBoxState: 'hide',
        searchTextBox: 'search-box is-disabled',
        searchBtnState: 'hide',
        clearBtnState: 'small button',
      });
    }
  };

  handleSearchForAnsOnly = () => {
    this.setState({ checkboxStatus: 1 });
    this.handleSearchRadio(ANSWER);
  };

  handleSearchForAnsQues = () => {
    this.setState({ checkboxStatus: 2 });
    this.handleSearchRadio(QUESTION_ANSWER);
  };
  
  handleSearchForAll = () => {
    this.setState({ checkboxStatus: 3 });
    this.handleSearchRadio(ALLRECORDS);
  };

  doSearch = type => {
    this.props.dictionaryActions.searchDictionaryTree(
      this.props.loginResponse.data.token,
      this.props.loginResponse.data.uid,
      this.props.activeAccountId,
      this.props.moduleStudy.pn,
      type,
      this.searchBox.value,
    );
    this.props.dictionaryActions.dictionaryTargetReset();
  };

  handleClear = (event, ss) => {
    let studyType = this.props.moduleStudy? this.props.moduleStudy.ss : '';
    studyType = ss || studyType;
    const checkboxStatus = studyType === 'MRI' ? 3 : 1;
    if (event) {
      event.preventDefault();
      this.props.dictionaryActions.getDictionaryTreeLoad(
        this.props.loginResponse.data.token,
        this.props.loginResponse.data.uid,
        this.props.activeAccountId,
        this.props.moduleStudy.pn,
        0,
        ALL
      );
      this.props.dictionaryActions.dictionaryTargetReset();
    }
    this.searchBox.value = '';
    this.setState({
      searchBoxState: 'hide',
      searchBtnState: 'button search-button',
      clearBtnState: 'hide',
      searchTextBox: 'search-box',
      checkboxStatus,
    });
  };

  render() {
    return (
      <div>
        <div className="search-component">
          <div className="row expanded">
            <div className="dictionary-search-input-box">
              <input
                type="text"
                id="right-label"
                placeholder="Search..."
                className={`${this.state.searchTextBox} dictionary-search-input`}
                onChange={this.handleSearchText}
                onKeyPress={e => this.handleKeyPress(e)}
                autoComplete="off"
                ref={searchBox => {
                  this.searchBox = searchBox;
                }}
                autoFocus
              />
              <button
                type="button"
                className={`${this.state.searchBtnState} button dictionary-search-input-button`}
                onClick={this.handleSearch}
              >
                <i className="fa fa-search" />
              </button>
              <button
                type="button"
                className={`${this.state.clearBtnState} button dictionary-search-input-button`}
                onClick={this.handleClear}
                ref={node => (this.clearBtn = node)}
              >
                <img title="Clear All" src={clearIcon} alt="clear" />
              </button>
            </div>
          </div>
          <div className="search-option-ctr">
            <div className="row expanded">
              <p className="left-align">
                <input
                  type="radio"
                  id="answers-only"
                  name="search-options"
                  defaultChecked={this.state.checkboxStatus === 1}
                  onClick={this.handleSearchForAnsOnly}
                  value="answers-only"
                  className={this.state.isDisabled}
                  checked={this.state.checkboxStatus === 1}
                />
                <label htmlFor="answers-only">
                  <span>Answers Only</span>
                </label>
              </p>
              <p className="left-align">
                <input
                  type="radio"
                  name="search-options"
                  value="questions-and-answers"
                  id="questions-and-answers"
                  onClick={this.handleSearchForAnsQues}
                  className={this.state.isDisabled}
                  defaultChecked={this.state.checkboxStatus === 2}
                  checked={this.state.checkboxStatus === 2}
                />
                <label htmlFor="questions-and-answers">
                  <span>Question and Answers</span>
                </label>
              </p>
              <p className="left-align">
                <input
                  type="radio"
                  name="search-options"
                  value="all"
                  id="all"
                  onClick={this.handleSearchForAll}
                  className={this.state.isDisabled}
                  defaultChecked={this.state.checkboxStatus === 3}
                  checked={this.state.checkboxStatus === 3}
                />
                <label htmlFor="all">
                  <span>All</span>
                </label>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SearchComponentV2.propTypes = {
  dictionaryTree: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  dictionaryActions: PropTypes.shape({
    getDictionaryTreeLoad: PropTypes.func,
    searchDictionaryTree: PropTypes.func,
    dictionaryTargetReset: PropTypes.func,
  }),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      token: PropTypes.string,
      uid: PropTypes.number,
    }),
  }),
  activeAccountId: PropTypes.number,
  moduleStudy: PropTypes.shape({
    pn: PropTypes.number,
    ss: PropTypes.string,
  }),
  refreshFlag: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    dictionaryTree: state.dictionary.dictionaryTree,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dictionaryActions: bindActionCreators(dictionaryActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchComponentV2);
